module.exports = __webpack_public_path__ + "img/world_of_acredo@2x.25756d3.jpg";